export var noResultsItems = [{ value: 'No results', onClick: function () { return console.log('No results'); }, disabled: true }];
